import { Workspace } from '@sr-sdks/api-sdk-axios';
import { Card, CardContent } from '@sr/ui-library';
import { UseFormReturn } from 'react-hook-form';
import { ContactNumberField } from './fields/contactNumber/ContactNumberField';
import { ContactRoleFields } from './fields/contacts/ContactRoleField';
import { WebsiteField } from './fields/website/WebsiteField';
import { WorkspaceDetailsFormValues } from './shared/types';

interface WorkspaceDetailsContactSectionProps {
  form: UseFormReturn<WorkspaceDetailsFormValues>;
  workspace: Workspace;
}

/**
 * Contact section — pure UI. Owns no form state; receives the shared form
 * instance from WorkspaceDetailsForm and submits through the unified
 * PATCH /workspace/:id/details call (APP-1828). Not feature-flagged — ships
 * with the MSR3 settings page.
 */
export const WorkspaceDetailsContactSection = ({
  form,
  workspace,
}: WorkspaceDetailsContactSectionProps) => (
  <section className="space-y-4">
    <h2 className="text-base font-medium text-neutral-950">Contact</h2>

    <Card className="rounded-lg border-neutral-300 shadow-none @container">
      <CardContent className="grid grid-cols-1 gap-x-4 gap-y-6 p-5 @2xl:grid-cols-2">
        <ContactRoleFields control={form.control} workspace={workspace} />

        <ContactNumberField control={form.control} />

        <WebsiteField control={form.control} />
      </CardContent>
    </Card>
  </section>
);
